<template>
  <div class="app-down">
    <div class="title">{{ $route.params.type | titleFilters }}</div>
    <div class="logo">
      <img :src="$route.params.type | logosType" alt />
    </div>
    <div class="success_down">
      <van-button
        color="#FBC02D"
        type="primary"
        plain
        size="large"
        @click="toDown"
        >{{ $route.params.type == 3 ? "Download" : "下載APP安裝" }}</van-button
      >
    </div>
  </div>
</template>
<!-- Global site tag (gtag.js) - Google Analytics -->
<script async src="https://www.googletagmanager.com/gtag/js?id=G-7CH9447NP2"></script>
<script>
// https://m.kingsarts.com/#/appDown/1
import mixinDown from "@/pages/mobile/views/mixin/mixinDown";
export default {
  mixins: [mixinDown],
  filters: {
    logosType(type) {
      let arr = [
        "",
        require("../../../../assets/img/KingsArts-icon-180.png"),
        require("../../../../assets/img/merchant-icon-logo.jpg"),
      ];
      return arr[type];
    },
    titleFilters(type) {
      let arr = ["", "歡迎下載經藝聯APP", "歡迎下載經藝聯賣家APP"];
      return arr[type];
    },
  },
  data() {
    return {
      type: this.$route.params.type || 1, // 1 爱好者 2 卖家
    };
  },
  created() {
    document.title = this.type == 2 ? "經藝聯賣家APP下載" : "經藝聯APP下載";
    this.toDown();

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    gtag("config", "G-7CH9447NP2");
  },
  methods: {
    toDown() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // alert('是否是Android：'+isAndroid);
      // alert('是否是iOS：'+isiOS);
      let sourceType = this.$route.query.sourceType || ""; //0:国内 1:海外
      if (isAndroid && sourceType == 0) {
        // 港 爱好者 安卓下载
        // window.location.href=`https://play.google.com/store/apps/details?id=cn.kingsarts.jingyi`;
        window.location.href = `market://details?id=cn.kingsarts.jingyi`;
      } else if (isiOS && sourceType == 0) {
        //港 爱好者 ios 下载
        window.location.href = `https://apps.apple.com/hk/app/經藝聯/id1524247193`;
      } else if (isAndroid && sourceType == 1) {
        // 海外 安卓下载
        window.location.href = `https://play.google.com/store/apps/details?id=cn.kingsarts.caaa`;
      } else if (isiOS && sourceType == 1) {
        // 海外 ios下载
        // window.location.href=`https://apps.apple.com/hk/app/經藝聯賣家/id1524254951`;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.app-down {
  width: 100%;
  height: 1200px;
  background: url("../../../../assets/img/jyw_share_reg__bg.png") no-repeat;
  background-size: 100% 100%;
  border-top: 1px solid transparent;
  .title {
    text-align: center;
    font-weight: 600;
    font-size: 36px;
    padding: 200px 0 30px;
  }
  .logo {
    width: 180px;
    height: 180px;
    margin: 10px auto 0;
    border-radius: 8px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
  .success_down {
    margin: 96px 168px;
  }
}
</style>